import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Trash2 } from 'lucide-react';

const AdminContact = () => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
        withCredentials: true
      });
      setMessages(data);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="space-y-6">
      {messages.length === 0 ? (
        <div className="bg-white p-8 rounded-2xl border border-slate-200 text-center text-slate-500">
          Henüz mesaj bulunmuyor.
        </div>
      ) : (
        messages.map(msg => (
          <div key={msg._id} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
            <div className="flex justify-between items-start mb-4">
              <div>
                <h3 className="font-bold text-slate-900 text-lg">{msg.subject}</h3>
                <p className="text-sm text-slate-500">{msg.name} ({msg.email})</p>
              </div>
              <span className="text-xs font-medium text-slate-400 bg-slate-100 px-3 py-1 rounded-full">
                {new Date(msg.date_created).toLocaleString('tr-TR')}
              </span>
            </div>
            <p className="text-slate-700 whitespace-pre-line bg-slate-50 p-4 rounded-xl text-sm leading-relaxed">
              {msg.message}
            </p>
          </div>
        ))
      )}
    </div>
  );
};

export default AdminContact;
